import React, {FC, Fragment, JSX, ReactNode} from "react";
import {Check12x9Svg} from "../../../svg";
import cls from "./customInnerPage.module.scss"
import {concatFilters, swatchTypeHandlerClass} from "./helpers";

export interface IConfigFilters {
    handleChangeConfig: ({attribute_id, id}: { attribute_id: number, id: number }) => void;
    configurableData: Array<{
        attributes_values: Array<{
            code: string;
            translations: Array<{ locale: string; label: string; name: string }>;
            attribute_options: Array<{
                id: number;
                attribute_id: number;
                swatch_value: string;
                translations: Array<{ locale: string; label: string; name: string }>;
                colorsStyle: string;
                sort_order: number
            }>
        }>;
        [x: string]: number[] | object
    }>;
    filtered: Record<string | number, string | number>;
}

export interface IColorLayout {
    colorOrNot: boolean;
    children: ReactNode;
    divId: string;
    swatch_value: string,
    colorsStyle: string
}


const ColorLayout: FC<IColorLayout> = (
    {
        colorOrNot,
        children,
        divId,
        swatch_value,
        colorsStyle
    }
) => {
    const colorOrNotLayoutHandle: Record<string, JSX.Element> = {
        "true": <div className={cls["filter-color__item"]} id={divId}>
            <span className={`
                    ${cls["filter-color__check"]}
                    ${cls["input-check-color"]}
                    ${cls[swatchTypeHandlerClass[`${swatch_value === "white"}`][`${swatch_value === 'light'}`]]}
                `}
                  style={{color: `${colorsStyle}`.toLowerCase()}}
            >
                {children}
            </span>
        </div>,
        "false": <Fragment>{children}</Fragment>
    }
    return colorOrNotLayoutHandle[`${colorOrNot}`]
};

const CustomConfigurableFilters: FC<IConfigFilters> = (
    {
        handleChangeConfig,
        configurableData,
        filtered
    }
) => {
    console.log(filtered, "filtered")
    return <div className={cls.config_filters}>
        {configurableData.map((attributes, index) => {
            const {
                attributes_values: [{translations: [{name: widgetName = ""}], code, attribute_options}],
                ...selectedAttributeObj
            } = attributes
            const [selectedAttribute] = Object.keys(selectedAttributeObj)
            return (
                <div key={index}
                     className={`${cls[concatFilters[`${code === 'color'}`].mainDivClass]} ${cls.attr_space}`}>
                    <div className={cls.attr_label_size}>{widgetName + " :"}</div>
                    <div className={cls[concatFilters[`${code === 'color'}`].childDivClass]}>
                        {attribute_options.map((
                            {translations: [{label = []}], id, attribute_id: attrID, swatch_value, colorsStyle},
                            i: number
                        ) => {
                            const propsWithColor: Record<string, {
                                labelProps: Record<string, any>,
                                inputClassName: string
                            }> = {
                                "true": {
                                    labelProps: {className: cls["input-check-color__body"]},
                                    inputClassName: "input-check-color__input"
                                },
                                "false": {
                                    labelProps: {htmlFor: code + id, id: id + code},
                                    inputClassName: "other-radio__input"
                                }
                            }
                            if (!(attributes[selectedAttribute] as number[]).some((el) => el === id)) return null;
                            return (
                                <ColorLayout key={i} colorOrNot={code === 'color'} divId={id + code}
                                             swatch_value={swatch_value} colorsStyle={colorsStyle}>
                                    <label {...propsWithColor[`${code === 'color'}`].labelProps}>
                                        <input
                                            hidden
                                            id={code + id}
                                            className={cls[propsWithColor[`${code === 'color'}`].inputClassName]}
                                            type="radio"
                                            name={code}
                                            value={id}
                                            checked={filtered[attrID] === id}
                                            onClick={() => handleChangeConfig({attribute_id: attrID, id})}
                                            //TODO !!! if we dont need this remove
                                            readOnly
                                        />
                                        {(() => {
                                            return {
                                                "false": () => {
                                                    const labelShowToggle = {
                                                        "true": label.slice(0, 13) + '...',
                                                        "false": label
                                                    }
                                                    return (
                                                        <div className={cls["label-attr__code"]}>
                                                            {labelShowToggle[`${label.length > 16}`]}
                                                        </div>
                                                    )
                                                },
                                                "true": () => <Fragment>
                                                    <span className={cls["input-check-color__box"]}/>
                                                    <Check12x9Svg className={cls["input-check-color__icon"]}/>
                                                    <span className={cls["input-check-color__stick"]}/>
                                                </Fragment>
                                            }
                                        })()[`${code === 'color'}`]()}
                                    </label>
                                </ColorLayout>
                            )
                        })}
                    </div>
                </div>
            )
        })}
    </div>
};

export default CustomConfigurableFilters